module.exports = __webpack_public_path__ + "assets/Heebo-Bold.fd5e5f32c1f438ecf5dd71d6ae01b049.ttf";